import React from 'react';
import { DocumentResponse } from 'types/api-responses';
import { getDocumentFields } from 'components/document-attributes/utils';

import style from './document-attributes-detail-view.module.scss';

const DocumentAttributesDetailView: React.FC<{
  document: DocumentResponse;
}> = ({ document }) => {
  const fields = getDocumentFields(document);

  return (
    <div className={style.documentAttributes}>
      <h3 className={style.title}>Details</h3>
      <div className={style.attributesGrid}>
        {fields.map(({ label, render }) => (
          <div key={label} className={style.attributeItem}>
            <span className={style.label}>{label}</span>
            <span className={style.value}>{render(document)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export { DocumentAttributesDetailView };
